"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setAutoFocusDisabled = void 0;
var _actionGenerator = require("../../types/redux/actionGenerator");
var _types = require("./types");
const setAutoFocusDisabled = exports.setAutoFocusDisabled = (0, _actionGenerator.actionGenerator)(_types.EAutoFocusDisabledActionTypes.SetAutoFocusDisabled);